module.exports = __webpack_public_path__ + "static/media/vergnano-512.20912605.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/vergnano-512.png
// module id = 788
// module chunks = 0